import { Component } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { MealTimesService } from 'src/app/Services/meal-times.service';

import * as moment from 'moment';
import { Time } from '@angular/common';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type MealTimes = {
  aiiActivityDesc: string;
  aiibegtime: Time;
  aiiendtime: Time;
  aiiActivityName: string;
  aiiLocationName: string;
  aiiDisplayLocationName: string;
};

@Component({
  selector: 'app-meal-times',
  templateUrl: './meal-times.component.html',
  styleUrls: ['./meal-times.component.css'],
  providers: [MealTimesService],
})
export class MealTimesComponent {
  userdata?: UserData;
  evtCode: string | undefined;
  OBPortalSvcURL = '';

  MealtimesInfo!: MealTimes[];
  mealtimedata: any;
  asofdate: string | undefined;

  constructor(
    private appConfigService: AppConfigService,
    private MealTimesService: MealTimesService
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    this.evtCode = cruiseContentEvtCodeFromSession(this.userdata);
    this.asofdate = moment().format('YYYY-MM-DD');

    this.getMealTimes();
  }

  getMealTimes() {
    this.mealtimedata = this.MealTimesService.getMealTimes(
      this.evtCode,
      this.asofdate
    ).subscribe((mealtimedata) => this.setMealTimes(mealtimedata));
  }

  setMealTimes(resdata: any) {
    this.mealtimedata = resdata;
    if (this.mealtimedata.GetMealTimes.Result.Status == 'A') {
      this.MealtimesInfo = this.mealtimedata.GetMealTimes.MealTimeList.filter(
        (s: { aiiActivityName: string }) =>
          (s.aiiActivityName.includes('Breakfast') ||
            s.aiiActivityName.includes('Lunch') ||
            s.aiiActivityName.includes('Dinner') ||
            s.aiiActivityName.includes('Ellipse Cafe')) &&
          s.aiiActivityName != "Early Riser's Breakfast"
      );
      //remove the extra words for breakfast, lunch and dinner from the display
      this.MealtimesInfo.forEach((currentValue, index) => {
        if (currentValue.aiiActivityName.includes('Breakfast'))
          currentValue.aiiActivityName = 'Breakfast';
        if (currentValue.aiiActivityName.includes('Lunch'))
          currentValue.aiiActivityName = 'Lunch';
        if (currentValue.aiiActivityName.includes('Dinner'))
          currentValue.aiiActivityName = 'Dinner';
      });
    }
  }
}
